import React from 'react';
import { Box, Button } from '@mui/material';
import { useStyles } from './styles';

const FilterControls = ({
    handleClearFilters,
    currentCount,
    totalRecordCount,
    objectType,
    handleResetToDefault,
    handleSaveNewDefault,
    isDefaultFilters,
}) => {
    const classes = useStyles();

    return (
        <Box className={classes.controls}>
            <Button
                onClick={() => handleClearFilters()}
                className={classes.text}
            >
                clear all filters
            </Button>
            {/* TODO - This will be commented for now until the feature is built in. */}
            {/* <Typography className={classes.separator}>|</Typography>
      <Button 
        onClick={() => handleResetToDefault()} 
        className={classes.text}
        disabled={isDefaultFilters}
      >
        reset to default
      </Button>
      <Typography className={classes.separator}>|</Typography>
      <Button 
        onClick={() => handleSaveNewDefault()} 
        className={classes.text}
        disabled={isDefaultFilters}
      >
        save new default
      </Button> */}
        </Box>
    );
};

export default FilterControls;
